module.exports = __webpack_public_path__ + "img/Total-revenue.47a92f8.png";